import {post} from './carbonApi';

const BASE_URL = process.env.API_URL + "/quotes/v1/money";

export function getQuoteApiForMoney(quoteData) {
  return post(BASE_URL, JSON.stringify(quoteData))
    .then(response => response.json())
    .then(result => result)
    .catch(e => console.error(e));
}